import React from 'react'
import { Route, Switch } from 'react-router-dom'

import {
  AuthPage,
  RestorePasswordPage,
  ChangePasswordPage
} from '../containers/Pages/Main'
import AuthPageWrapper from '../components/UI/AuthPageWrapper'
import { withAuth } from '../containers/HOC'

const Routes = () => {
  return (
    <AuthPageWrapper>
      <Switch>
        <Route path="/change-password" component={ChangePasswordPage} />
        <Route path="/restore-password" component={RestorePasswordPage} />
        <Route path="/" component={AuthPage} />
      </Switch>
    </AuthPageWrapper>
  )
}

export default withAuth(Routes)
